export default __webpack_public_path__ + "static/media/call-a-person-video-call.ef653067.svg";